import React from "react";
import classNames from "classnames";
import styles from "./index.module.scss";
import { t } from "i18next";

export interface ProductDispatchItem {
  id: string;
  name: string;
  from: number | null | undefined;
  to: number | null | undefined;
  index: string;
}

interface ProductDispatchProps {
  dispatch: ProductDispatchItem[];
  active: string;
  isShipNextBusinessDay?: boolean;
  className?: string;
  onUpdateActive?: (id: string) => void;
}

const renderOption = (item: ProductDispatchItem) => {
  if (item.from === item.to || item.from == null || item.to == null) {
    const deliveryTerm = t("rfje423vfw3fj4hv.delivery-term", "{{deliveryTerm}} days", { deliveryTerm: item.from ?? item.to ?? "" });

    return `${deliveryTerm}${item.index ? ` ${item.index}` : ""}`;
  }

  return `${t("zk32um9soyc445h3.dispatch-time-range", "{{from}}-{{count}} days {{index}}", { count: item.to, from: item.from, index: item.index || "" })}`;
};

const ProductDispatch: React.FC<ProductDispatchProps> = ({ dispatch, active, isShipNextBusinessDay = false, className, onUpdateActive }) => {
  if (isShipNextBusinessDay) {
    return (
      <div className={classNames(styles['dispatch-time'], className)}>
        <div className={styles.label}>{t("bs6v90iqxu790208.dispatch-time", "Dispatch time")}:</div>
        <div className={styles.value}>{t("bs6x10iqxu790209.next-business-day", "Next business day")}</div>
      </div>
    );
  }

  return (
    <div className={classNames(styles['dispatch-time'], className)}>
      <div className={styles.label}>{t("bs6v90iqxu790208.dispatch-time", "Dispatch time")}:</div>
      <div className={styles.value}>{renderOption(dispatch[0])}</div>
    </div>
  );
};

export default ProductDispatch;
